export default "__VITE_ASSET__elD_Sd9r__"